import AllowanceSummary from '@/models/reporting/AllowanceSummary'

export default class OvertimeAllowanceSummary extends AllowanceSummary {}
